// Berechnungszeile der Lead-Listen (Runde 10, Agent 10B): Typen und Client nach crm/API.md, Abschnitt „Runde 10 · 10B“.
import { http } from "./client";
import type { Abfrage } from "./filter";
import type { BerechnungsErgebnis, BerechnungsFunktion } from "../components/liste/berechnungModell";

/** Woher die Treffer kommen: genau eine Quelle. */
export type BerechnungsZiel =
  | { view_id: string }
  | { s_query: Abfrage }
  | { lead_ids: string[] }
  | { liste: true; q?: string; status_id?: string[] };

export interface BerechnungsAntwort {
  /** Leads, über die gerechnet wurde */
  anzahl: number;
  /** Treffer der Liste insgesamt (größer als `anzahl`, wenn der Server bei 20.000 Leads kappt) */
  gesamt: number;
  gekappt: boolean;
  ergebnisse: Record<string, BerechnungsErgebnis>;
}

export interface UngekuerzteZahl {
  /** Treffer ohne das Limit */
  gesamt: number;
  limit: number | null;
  /** Treffer mit Limit */
  angezeigt: number;
}

export const listenBerechnungApi = {
  leads: (ziel: BerechnungsZiel, berechnungen: Record<string, BerechnungsFunktion>) =>
    http.post<BerechnungsAntwort>("/api/listen-berechnung/leads", { ziel, berechnungen }),
  /** Trefferzahl einer Abfrage, als stünde dort kein Limit (für „100 von 5.312 Leads“) */
  anzahlOhneLimit: (s_query: Abfrage) => http.post<UngekuerzteZahl>("/api/listen-berechnung/anzahl", { s_query }),
};
